import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { FreeTrialService } from '../free-trial.service';
import { ImagilityBaseResponse } from '../../../data/models/response.model';
import { MatDialog } from '@angular/material/dialog';
import { ClientCompanyComponent } from '../client-company/client-company.component';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { ConfirmationModalComponent } from 'src/app/modules/shared/modal/confirmation-modal/confirmation-modal.component';
import { Store } from '@ngrx/store';
import { MarkCleanFormAction, MarkDirtyFormAction } from 'src/app/app-state/actions/dirty-form.actions';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import { ToastrService } from 'ngx-toastr';
import { AddUserComponent } from '../add-user/add-user.component';

@Component({
  selector: 'app-add-client-company',
  templateUrl: './add-client-company.component.html',
  styleUrls: ['./add-client-company.component.scss'],
  providers: [ConfirmationService]
})
export class AddClientCompanyComponent implements OnInit {

  @Output() notify: EventEmitter<number> = new EventEmitter<number>();
  @ViewChild(AddUserComponent) cc: AddUserComponent;

  @Input() companyId;
  displayedColumns: string[] = ['company', 'contact', 'email', 'action'];
  dataSource: MatTableDataSource<any>;
  dirtyFlag: boolean = false;
  addClientCompanyBtn: boolean = false;
  summaryDisplayForm: FormGroup;
  public userDetails:any= [];
  public userDetails1:any= [];
  attorneypetitionerUser: string;
  editcompanyuserfirstname: string;
  editcompanyuserlastname: string;
  userCompanyFirmInfo1: any;

  constructor(
    private freeTrialService: FreeTrialService,
    public dialog: MatDialog,
    private router: Router,
    private confirmationService: ConfirmationService,
    protected store: Store<any>,
    private fb: FormBuilder,
    private primengConfig: PrimeNGConfig,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
   this.summaryDisplayForm = this.fb.group({
    companyName: [''],
    contact: [''],
    email: [''],
    address: [''],
    username: ['']
    });
  }

  getClientCompanyDetails() {
   let clientFirmInfo = this.freeTrialService.getCompanyClientFirmInfo();
   let userCompanyFirmInfo = this.freeTrialService.getattorneyUserInfoArray();
   let userCompanyFirmInfoedit = this.freeTrialService.getCompanyClientFirstLastName();
   this.userDetails[0] = clientFirmInfo;
   for (let attorneypetitioneruser of userCompanyFirmInfo) {
   this.attorneypetitionerUser = attorneypetitioneruser.firstName + ' ' + attorneypetitioneruser.lastName + ' ( Petitioner Admin ) ';
   this.summaryDisplayForm.patchValue({
    companyName: clientFirmInfo.company.companyName,
    contact: clientFirmInfo.company.mobileContacts,
    email: clientFirmInfo.company.emailContact.email,
    address: clientFirmInfo.company.address1,
    username: attorneypetitioneruser.firstName + ' ' + attorneypetitioneruser.lastName ,
  });
}
  }

  editNewUser(data: any) {
    this.dialogueInitializerViewClientCompany(data);
  }

  dialogueInitializerViewClientCompany(data) {
    const dialogRef = this.dialog.open(ClientCompanyComponent, {
      width: '1400px',
      height: '600px',
      data: {
         data
      }
    }).afterClosed().subscribe(result => {
      this.getClientCompanyDetails();
      this.addClientCompanyBtn = true;
      if (!result) {
       this.getClientCompanyDetails();
     }
      if (result) {
       this.getClientCompanyDetails();
     }
   });
  }

  dialogueInitializer(event, title: string, message: string, buttons: any[]) {
    const cordinates: MouseEventInit = event;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      width: '400px',
      data: {
        update: { title, message },
        // tslint:disable-next-line:object-literal-shorthand
        buttons: buttons
      }
    });
    return dialogRef;
  }

  confirmDelete(details) {
    this.userCompanyFirmInfo1 = this.freeTrialService.getattorneyUserInfoArray();
    const title = 'Confirm';
    const message = 'Do you wish to remove this item?';
    const buttons = ['Cancel', 'Delete'];

    this.dialogueInitializer(event, title, message, buttons).afterClosed().subscribe(result => {
      if (result) {
        this.toastr.success("Company deleted successfully", 'Success');
        let index = this.userDetails.indexOf(details);
        this.userDetails.splice(index, 1);
        this.userCompanyFirmInfo1.length = 0;
        this.freeTrialService.setCompanyClientFirmInfo(null);
        this.addClientCompanyBtn = false;
      }
    });
  }

  viewConnection() {

    const dialogRef = this.dialog.open( ClientCompanyComponent , {
      width: '1400px',
        height: '600px',
        disableClose: true,
    }).afterClosed().subscribe(result => {
       if (!result) {
        this.addClientCompanyBtn = true;
        this.getClientCompanyDetails();
      }
    });
  }

    getFreeTrialList()
    {
      let payload = {
        pageNumber: 0,
        pageSize: 2
      };
      this.freeTrialService.getFreeTrialList(payload).subscribe((response: ImagilityBaseResponse) => {
        if (response.data)
        {
          this.getFreeTrialList = response.data.elements;
        }
      });
    }

    onPrevious(){
      this.confirmationService.close();
      this.notify.emit(1);
    }

    onNext() {
      this.notify.emit(3);
    }

    onCancel(){
      if (this.dirtyFlag) {
        this.dialog.open(ConfirmationModalComponent, {
          width: '400px',
          data: {
            update: {
              title: 'Unsaved Changes!',
              message: 'Changes you made on this section is not saved yet. Do you wish to continue?'
            },
            // buttons: ['No, Stay on the Page', 'Yes, Leave the Page']
            buttons: ['No', 'Yes'],
            disableClose: true
          }
        }).afterClosed().subscribe(confirmed => {
          if (confirmed) {
            this.store.dispatch(new MarkCleanFormAction({ dirty: false }));
            this.dirtyFlag = false;
            this.router.navigate([`/login/login/signin`]);
          }
        });
  
      } else {
        this.router.navigate([`/login/login/signin`]);
      }
    }
}
